export interface PurchaseOrderDocumentStatusItem {
  id: string;
  orderStatus: string;
  user: string;
  processedDate: Date;
  reportType: string;
}
